type User = {
  firstName: string;
  lastName: string;
};

type Address = {
  street?: string;
  postalCode?: string;
  city?: string;
};

/**
 * Constructs the full name from a user object.
 */
export const fullName = (currentUser: User, separator: string): string =>
  `${currentUser.firstName}${separator} ${currentUser.lastName}`;

/**
 * Constructs the full address string including postal code.
 */
export const fullAddress = (
  address: Address | null | undefined,
): string | undefined => {
  if (!address) return undefined;

  const parts = [address.street, address.postalCode, address.city].filter(
    Boolean,
  );
  return parts.join(" · ");
};
